"use client";

import { SlidersHorizontal } from "lucide-react";
import { useTranslations } from "next-intl";
import { useSearchFilterBridge } from "@/lib/search/filter-bridge";

/**
 * 모바일 상단 검색바 오른쪽 필터 버튼(09-28, 에어비앤비 방식) — 검색 페이지 헤더에만 있고
 * 그 페이지의 필터 드로어를 연다(로딩 중엔 비활성). 적용 중인 필터가 있으면 주황 점.
 * sm(640) 이상은 페이지 안 필터 줄에 [필터] 가 있으므로 숨긴다.
 */
export function FilterNavButton() {
  const t = useTranslations("searchComposer");
  const bridge = useSearchFilterBridge();
  // 검색 페이지가 아직 로딩 중이면(등록 전) 같은 자리에 비활성 버튼 — 로드 순간 검색 알약
  // 폭이 줄며 튀지 않게 한다. 이 버튼은 검색 페이지 헤더에만 있다(Navbar region).
  return (
    <button
      type="button"
      onClick={bridge?.open}
      disabled={!bridge}
      aria-label={t("openFilters")}
      className="relative flex size-10 shrink-0 items-center justify-center rounded-full text-gray-800 hover:bg-gray-100 disabled:text-gray-300 disabled:hover:bg-transparent sm:hidden"
    >
      <SlidersHorizontal className="size-5" />
      {!!bridge && bridge.active > 0 && (
        <span className="absolute right-1.5 top-1.5 size-2 rounded-full bg-orange-500 ring-2 ring-white" />
      )}
    </button>
  );
}
